import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'iniciais'
})
export class IniciaisPipe implements PipeTransform {

  transform(value: any): any {
    const array = value.split(' ');
    let primeira: any;
    let segunda: any;
    if (array) {
      primeira = array[0].slice(0, 1);
      if (array.length > 1){
        segunda = array[(array.length - 1)].slice(0, 1);
        return primeira + segunda;
      } else {
        return primeira;
      }
    }
  }
}
